import axios from "axios";

export const https = (baseURL = "", token) => {
  const instance = axios.create({
    baseURL: `https://sphqi.com.br${baseURL}`,
    timeout: 600000,
    headers: {
      "x-access-token": token
    }
  });
  return instance;
};
